import axios from "../axiosInstance"

export interface Notification {
  id: number
  esoPersonId: number
  dealId: number | null
  type: string
  title: string
  message: string
  metadata: any
  isRead: boolean
  createdAt: string
  deal: {
    id: number
    dealIdStr: string
    company: { name: string }
    client: { firstName: string; lastName: string }
  } | null
}

export const getNotifications = async (params?: {
  unreadOnly?: boolean
  limit?: number
  offset?: number
  dealId?: number
}): Promise<Notification[]> => {
  const res = await axios.get("/notifications", { params })
  return res.data
}

export const getUnreadCount = async (): Promise<number> => {
  const res = await axios.get("/notifications/unread-count")
  return res.data.count
}

export const markNotificationAsRead = async (id: number): Promise<void> => {
  await axios.put(`/notifications/${id}/read`)
}

export const markAllNotificationsAsRead = async (): Promise<void> => {
  await axios.put("/notifications/read-all")
}
